import React from "react";
import SectionBgImg from "../components/SectionBgImg";
import NumberedHeading from "../components/NumberedHeading";
import { MdPersonOutline } from "react-icons/md";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { detailedResultState } from "../../../utils/recoil";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

const InterestArea = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result")
  return (
    <div className="py-20">
      <NumberedHeading
        number={"5"}
        title={t("interestArea.title")}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <div className="my-10 px-[20rem] lg:lg-small:px-[15rem] md-max:px-[1rem] relative">
        <SectionBgImg className={"top-1/2 -translate-y-1/2"} />
        <div className="bg-white shadow-xl z-10 relative rounded-xl p-5 grid grid-cols-2 md-max:grid-cols-1 gap-x-5 gap-y-6">
          {data?.interests?.areas?.slice(0,4)?.map((item, index) => (
            <div
              key={index}
              className="bg-[#F1F7FF] rounded-[10px] flex md-max:flex-col justify-center gap-4 items-center group z-30 p-8"
            >
              <div className="flex flex-col gap-1 text-center items-center w-1/2 md-max:w-full">
                <MdPersonOutline className="text-primary-blue" size={32} />
                <p className="text-2xl font-semibold">{item?.title}</p>
                <p className="text-[#4B5563] text-[16px] font-normal max-w-40 md-max:max-w-full">
                  {item?.description}
                </p>
              </div>
              <div className="relative size-36 w-1/2 md-max:w-full">
                <CircularProgressbar
                  value={item?.percentage}
                  className="
                  w-28 h-28 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  styles={buildStyles({
                    pathColor: "#3976F9",
                    trailColor: "transparent",
                  })}
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-blue/30 w-24 h-24 flex items-center justify-center text-xl font-semibold">
                  {item?.percentage} %
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InterestArea;
